export default __webpack_public_path__ + "static/media/gallery_01@2x.4b8b55c7.jpg";